class ShippingBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.threshold = this.dataset.threshold;
    this.totalPrice = this.dataset.totalPrice;
    this.moneyFormat = this.dataset.moneyFormat;

    this.successText = this.querySelector('[data-success-text]');
    this.progressText = this.querySelector('[data-progress-text]');
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.labelTo = this.querySelector('[data-label-to]');

    this.appendLabelTo();

    const thresholdIsPassed =
      Number(this.totalPrice) > Number(this.threshold);
    if (!thresholdIsPassed && Number(this.threshold) > 0) {
      this.showProgress();
      return;
    }

    this.progressBar.style.width = '100%';
    this.progressBar.parentElement.classList.remove('hidden');
    this.successText.classList.remove('hidden');
  }

  showProgress() {
    // Calculate progress percent
    const progressPercent = (this.totalPrice * 100) / this.threshold;
    this.progressBar.style.width = `${progressPercent}%`;

    // Replace price
    const progressText = this.progressText.innerHTML.replace(
      '[amount]',
      this.getFormattedPrice(this.threshold - this.totalPrice)
    );
    this.progressText.innerHTML = progressText;

    this.progressBar.parentElement.classList.remove('hidden');
    this.progressText.classList.remove('hidden');
  }

  appendLabelTo() {
    if (!this.labelTo) {
      return;
    }

    this.labelTo.innerHTML = this.getFormattedPrice(this.threshold);
  }

  getFormattedPrice(price) {
    const formattedPrice = Shopify.formatMoney(
      price,
      this.moneyFormat
    );
    return formattedPrice;
  }
}

customElements.define('shipping-bar', ShippingBar);
